// extracted by mini-css-extract-plugin
export default {"container":"EntityTag_container__d7I96"};